import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const FALLBACK_CENTRES = [
  { slug: "cinquantenaire", name: "Psymed Cinquantenaire", city: "Bruxelles", address_line: "Avenue de la Renaissance 21", photo: "/images/centre/centre-06.jpg" },
  { slug: "abbaye", name: "Psymed Abbaye", city: "Ixelles", address_line: "Avenue de l'Hippodrome 117", photo: "" },
];

export default function CentresPreview({ centres }) {
  const { t, language } = useLanguage();
  const list = centres.length > 0 ? centres : FALLBACK_CENTRES;
  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50/60" data-testid="centres-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="text-center mb-12">
          <p className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-[#2E4DB5] mb-3">
            {t.centres.eyebrow}
          </p>
          <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight mb-3">
            {t.centres.home_title}
          </h2>
          <p className="text-slate-600 max-w-xl mx-auto">{t.centres.home_subtitle}</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {list.map((c) => {
            const l = c.i18n?.[language] || c.i18n?.fr || {};
            return (
              <Link
                key={c.slug}
                to={`/centres/${c.slug}`}
                className="group relative bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 overflow-hidden"
                data-testid={`home-centre-${c.slug}`}
              >
                <div className="h-56 sm:h-64 overflow-hidden bg-slate-100 relative">
                  {c.photo ? (
                    <img src={c.photo} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-[#2E4DB5]/20 to-[#3B9DA5]/20 flex items-center justify-center">
                      <MapPin className="w-14 h-14 text-white/50" />
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent" />
                  <div className="absolute bottom-4 left-5 right-5">
                    <h3 className="font-outfit text-2xl sm:text-3xl font-bold text-white leading-tight" style={{ textShadow: "0 2px 8px rgba(0,0,0,0.4)" }}>
                      {c.name}
                    </h3>
                    <p className="text-white/85 text-sm mt-1 flex items-center gap-2" style={{ textShadow: "0 1px 4px rgba(0,0,0,0.4)" }}>
                      <MapPin className="w-3.5 h-3.5" /> {c.address_line}, {c.city}
                    </p>
                  </div>
                </div>
                <div className="p-6 flex items-center justify-between">
                  <p className="text-sm text-slate-600 line-clamp-2 flex-1 pr-4">{l.tagline}</p>
                  <span className="inline-flex items-center gap-1 text-[#2E4DB5] text-sm font-semibold whitespace-nowrap group-hover:gap-2 transition-all">
                    {t.centres.discover} <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
